import Vue from 'vue'
import Toast from '@/components/Toast.vue'

const ToastConstructor = Vue.extend(Toast)

let currentToast = null

function showToast(options) {
  if (currentToast) {
    currentToast.show = false
    setTimeout(() => {
      currentToast.$el.remove()
      currentToast = null
      createNewToast(options)
    }, 300) // 等待關閉動畫完成
  } else {
    createNewToast(options)
  }
}

function createNewToast(options) {
  const instance = new ToastConstructor({
    propsData: options
  }).$mount()
  document.body.appendChild(instance.$el)
  currentToast = instance
  return instance
}

const toast = {
  install(Vue) {
    Vue.prototype.$toast = {
      success(message, duration = 2000) {
        return showToast({ message, type: 'success', duration })
      },
      error(message, duration = 2000) {
        return showToast({ message, type: 'error', duration })
      }
    }
  }
}

export default toast